import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../../../core/components/Button';
import FlexLayout from '../../../../core/components/layout/FlexLayout';
import FilterIcon from '../../../../core/components/icons/FilterIcon';
import styles from './FilterButton.module.scss';

const FilterButton = ({ onPress }: { onPress?: () => void }) => {
    return (
        <div className={styles.filterButton}>
            <Button fullWidth secondary onPress={onPress} rounded size="small">
                <FlexLayout gap="mini" align="center">
                    <FlexLayout align="center" gap="none">
                        <FilterIcon />
                    </FlexLayout>
                    <FormattedMessage id="filter" />
                </FlexLayout>
            </Button>
        </div>
    );
};

export default memo(FilterButton);
